import React from 'react';
import PropTypes from 'prop-types';
import './SyllabusPage.css';

const SyllabusPage = () => (
  <div className="SyllabusPage">
    {/* SyllabusPage Component */}
  </div>
);

SyllabusPage.propTypes = {};

SyllabusPage.defaultProps = {};

export default SyllabusPage;
